import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";

export default function AdminLayout({ children }) {

    return (

        <div className="admin-wrapper">

            <Sidebar />

            <div className="content-wrapper">

                <Header />

                <div className="content">

                    {children}

                </div>

            </div>

        </div>

    );

}